import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (user) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        user: user
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = (logout = false) => {
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('user');

    return {
        type: actionTypes.AUTH_LOGOUT,
        logout: logout
    };
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

export const auth = (user, password, isSignup) => {
    return dispatch => {
        dispatch(authStart());

        window.flow.login(user, password).then((res) => {
            console.log(res);
            if (res.success) {
                dispatch(authSuccess(res.user));
                
                if (res.user.g.udo.standardview === '' || !res.user.g.udo.standardview || res.user.g.udo.standardview === undefined) {
                    dispatch(actions.setClipListViewMode('grid'));
                } else {
                    dispatch(actions.setClipListViewMode(res.user.g.udo.standardview));
                }

                if (res.user.g.udo.uilanguage) {
                    dispatch(actions.selectLanguage(res.user.g.udo.uilanguage.substr(0, 2)));
                }
                
                setMetadataConfig(dispatch, res.user);
                dispatch( actions.loadSoapApiDef() );
                
                /*
                // set metadata config
                import(`${process.env.REACT_APP_APPID}/config/metadata_clip.json`).then(module => {
                console.log(module);
                let config = {};
                config.clip = module.default;
                
                dispatch({type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS, config: config });
                dispatch( actions.loadSoapApiDef() );
                }).catch((error) => {
                    console.log("JSON IMPORT ERROR");
                    
                });
                */
            }
        }).catch(res => {
            dispatch(authFail(res.msg));
        });
    };
};

const setMetadataConfig = (dispatch, user) => {
	console.log("XXX");
    let config = {};
                
    if(user.g.udo.metadata_clip) {
        config[Metadata.OBJECT_TYPE_CLIP] = JSON.parse(user.g.udo.metadata_clip);
    }
    
    if(user.g.udo.metadata_project) {
        config[Metadata.OBJECT_TYPE_PROJECT] = JSON.parse(user.g.udo.metadata_project);
    }
    
    dispatch({type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS, config: config });
} 

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {

        //const user = JSON.parse(localStorage.getItem('user'));
        const user = undefined;
        if (typeof (user) === 'undefined' || typeof (window.flow) === 'undefined') {
            dispatch(logout());
        } else {

            dispatch(authSuccess(user));
            //dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));

        }
    };
};
